import Vue from 'vue'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const headerRealties = (data) => {
  const realties = data?.realties

  if (!realties && realties.length <= 0) return ''

  let realtiesContent = ''

  realtiesContent += `
    <h6 class="text-uppercase grey--text mt-2">
      ${translate(area + 'realties')}
    </h6>
  `

  realties.map((realty) => {
    realtiesContent +=  `
      <div class="d-block">
        <span class="mb-1 mt-1 v-chip v-chip--no-color theme--light v-size--small">
          ${realty.code}
        </span>
        <span class="body-2 ml-1">
          ${realty.address}
        </span>
      </div>
    `
  })

  return realtiesContent
}

export default headerRealties
